import DOMPurify from 'dompurify';
import {  makeGetCall  } from "../utils/helper";

// Input sanitization utilities
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') {
    return input;
  }

  // Remove dangerous characters and HTML
  const sanitized = DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true
  });

  // Additional sanitization for special characters
  return sanitized
    .replace(/[<>]/g, '') // Remove any remaining angle brackets
    .replace(/javascript:/gi, '') // Remove javascript: protocol
    .replace(/on\w+=/gi, '') // Remove event handlers
    .trim();
};

// Username validation
export const validateUsername = (username) => {
  const errors = [];

  if (!username || username.trim().length === 0) {
    errors.push('Username is required');
    return { isValid: false, errors };
  }

  const sanitizedUsername = sanitizeInput(username);

  // Check for minimum length
  if (sanitizedUsername.length < 3) {
    errors.push('Username must be at least 3 characters long');
  }

  // Check for maximum length
  if (sanitizedUsername.length > 50) {
    errors.push('Username must not exceed 50 characters');
  }

  return {
    isValid: errors.length === 0,
    errors,
    sanitizedValue: sanitizedUsername
  };
};

// Password validation (minimal - only length requirement)
export const validatePassword = (password) => {
  const errors = [];

  if (!password || password.length === 0) {
    errors.push('Password is required');
    return { isValid: false, errors };
  }

  // Check minimum length
  if (password.length < 4) {
    errors.push('Password must be at least 4 characters long');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

// Form validation utilities
export const validateLoginForm = (formData) => {
  const { username, password } = formData;
  const errors = {};

  // Validate username
  const usernameValidation = validateUsername(username);
  if (!usernameValidation.isValid) {
    errors.username = usernameValidation.errors;
  }

  // Validate password
  const passwordValidation = validatePassword(password);
  if (!passwordValidation.isValid) {
    errors.password = passwordValidation.errors;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
    sanitizedData: {
      username: usernameValidation.sanitizedValue || username,
      password: password // Don't sanitize password, just validate
    }
  };
};

// CSRF token utilities
export const generateCSRFToken = () => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

export const generateBackendCSRFToken = () =>   {
  console.log("Generating backend csrf token");
  //return "generating backend csrf token logic here";

  return makeGetCall('/csrf-token')
    .then(res => {
      console.log(res);
      const csrfToken = res.data?.csrfToken;
      sessionStorage.setItem('csrf_token', csrfToken);
      return res;
    })
    .catch(err => {
      console.error('Error fetching csrf token:', err);
      throw err;
    });
}

export const setCSRFToken = (token) => {
  // Set CSRF token in meta tag
  let metaTag = document.querySelector('meta[name="csrf-token"]');
  if (!metaTag) {
    metaTag = document.createElement('meta');
    metaTag.name = 'csrf-token';
    document.head.appendChild(metaTag);
  }
  metaTag.content = token;

  // Store in session storage for validation
  //sessionStorage.setItem('csrf_token', token);
};

export const getCSRFToken = () => {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ||
         sessionStorage.getItem('csrf_token');
};

export const validateCSRFToken = (token) => {
  const storedToken = getCSRFToken();
  return storedToken && token === storedToken;
};
